import { User } from '@sdk/users/types/User';
import Avatar from '@sdk/components/avatar/Avatar';
import Column from '@sdk/components/ui/spacing/Column';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Text12 from '@sdk/components/ui/typography/Text12';

import { getUserFormattedGroups } from '@web/common/utils/getUserFormattedGroups';
import { RowContainer } from '@web/newsfeed/components/UserPreviewListItem/userPreviewListItem.styles';
import { UserNameLink } from '@web/components/UserNameLink/UserNameLink';

type Props = {
  user: User;
};

export const UserPreviewListItem = ({ user }: Props) => (
  <RowContainer>
    <Avatar user={user} />
    <Column mLeft={8}>
      <UserNameLink user={user} />
      <Text12 themeColor={ThemeColorType.iconGray}>{getUserFormattedGroups(user, 45)}</Text12>
    </Column>
  </RowContainer>
);
